import React from 'react'
import { Switch } from 'react-router-dom'
import Loadable from './Loadable'
import RoutePermission from '../../../lib/routePermission'

const AsyncHome = Loadable({
	loader: () => import('../components/Home')
})

const AsyncNotFound = Loadable({
	loader: () => import('../components/NotFound')
})

const AsyncLoginBSRS = Loadable({
	loader: () => import('../../auth/components/LoginBSRS')
})

const AsyncSettingsIntegration = Loadable({
	loader: () => import('../../settings/integration/components/SettingIntegration')
})

const AsyncAuthorizeO365 = Loadable({
	loader: () => import('../../auth/components/AuthorizeO365')
})

const AsyncUserInfo = Loadable({
	loader: () => import('../../user/components/UserInfo')
})

const AsyncUserChangePassword = Loadable({
	loader: () => import('../../user/components/UserChangePassword')
})

const AsyncReportSummary = Loadable({
	loader: () => import('../../report/components/ReportSummary')
})

const AsyncUserReport = Loadable({
	loader: () => import('../../report/components/UserReport')
})

const AsyncRoomReportNew = Loadable({
	loader: () => import('../../report/components/RoomReportNew')
})

const AsyncUserSummary = Loadable({
	loader: () => import('../../report/components/UserSummary')
})

const AsyncRoomSummary = Loadable({
	loader: () => import('../../report/components/RoomSummary')
})

const AsyncFacilitySummary = Loadable({
	loader: () => import('../../report/components/FacilitySummary')
})

const AsyncReserveNotUseByUser = Loadable({
	loader: () => import('../../report/components/ReserveNotUseByUser')
})

const AsyncReserveNotUseByRoom = Loadable({
	loader: () => import('../../report/components/ReserveNotUseByRoom')
})

const AsyncReportUserAttendance = Loadable({
	loader: () => import('../../report/components/ReportUserAttendance')
})

const AsyncFoodSummary = Loadable({
	loader: () => import('../../report/components/FoodSummary')
})

const AsyncDeleteEventSummary = Loadable({
	loader: () => import('../../report/components/DeleteEventSummary')
})


const AsyncSetting = Loadable({
	loader: () => import('../../setting/components/Setting')
})

const AsyncChangeSetting = Loadable({
	loader: () => import('../../setting/components/ChangeSetting')
})

const AsyncListRoomsO365 = Loadable({
	loader: () => import('../../rooms/components/ListRoomsO365')
})

const AsyncListRoomsCore = Loadable({
	loader: () => import('../../rooms/components/ListRoomsCore')
})

const AsyncListRoomsSubscribe = Loadable({
	loader: () => import('../../rooms/components/ListRoomsSubscribe')
})

const AsyncCreateRoomNew = Loadable({
	loader: () => import('../../rooms/components/CreateRoom')
})

const AsyncUpdateRoomNew = Loadable({
	loader: () => import('../../rooms/components/UpdateRoom')
})

const AsyncViewRoomCore = Loadable({
	loader: () => import('../../rooms/components/ViewRoomCore')
})

const AsyncListUsersCore = Loadable({
	loader: () => import('../../user/components/ListUsersCore')
})

const AsyncListUsersO365 = Loadable({
	loader: () => import('../../user/components/ListUsersO365')
})

const AsyncListUsersAD = Loadable({
	loader: () => import('../../user/components/ListUsersAd')
})

const AsyncCreateUser = Loadable({
	loader: () => import('../../user/components/CreateUser')
})

const AsyncUpdateUser = Loadable({
	loader: () => import('../../user/components/UpdateUser')
})

const AsyncViewUserCore = Loadable({
	loader: () => import('../../user/components/ViewUserCore')
})

const AsyncAmenity = Loadable({
	loader: () => import('../../settings/amenity/components/ListAmenity')
})

const AsyncAmenityUpdate = Loadable({
	loader: () => import('../../settings/amenity/components/UpdateAmenity')
})

const AsyncViewAmenity = Loadable({
	loader: () => import('../../settings/amenity/components/ViewAmenity')
})

const AsyncAmenityCreate = Loadable({
	loader: () => import('../../settings/amenity/components/CreateAmenity')
})

const AsyncBuildingCreate = Loadable({
	loader: () => import('../../location/building/components/CreateBuilding')
})
const AsyncBuildingUpdate = Loadable({
	loader: () => import('../../location/building/components/UpdateBuilding')
})
const AsyncViewBuilding = Loadable({
	loader: () => import('../../location/building/components/ViewBuilding')
})
const AsyncBuilding = Loadable({
	loader: () => import('../../location/building/components/ListBuilding')
})

const AsyncBackgroundCreate = Loadable({
	loader: () => import('../../background/components/CreateBackground')
})
const AsyncBackgroundUpdate = Loadable({
	loader: () => import('../../background/components/UpdateBackground')
})
const AsyncViewBackground = Loadable({
	loader: () => import('../../background/components/ViewBackground')
})
const AsyncBackground = Loadable({
	loader: () => import('../../background/components/ListBackground')
})

const AsyncFloorCreate = Loadable({
	loader: () => import('../../location/floor/components/CreateFloor')
})
const AsyncFloorUpdate = Loadable({
	loader: () => import('../../location/floor/components/UpdateFloor')
})
const AsyncViewFloor = Loadable({
	loader: () => import('../../location/floor/components/ViewFloor')
})
const AsyncFloor = Loadable({
	loader: () => import('../../location/floor/components/ListFloor')
})

const AsyncZoneCreate = Loadable({
	loader: () => import('../../location/zone/components/CreateZone')
})
const AsyncZoneUpdate = Loadable({
	loader: () => import('../../location/zone/components/UpdateZone')
})
const AsyncViewZone = Loadable({
	loader: () => import('../../location/zone/components/ViewZone')
})
const AsyncZone = Loadable({
	loader: () => import('../../location/zone/components/ListZone')
})

const AsyncFbs = Loadable({
	loader: () => import('../../settings/fbs/components/ListFbs')
})

const AsyncFbsUpdate = Loadable({
	loader: () => import('../../settings/fbs/components/UpdateFbs')
})

const AsyncViewFbs = Loadable({
	loader: () => import('../../settings/fbs/components/ViewFbs')
})

const AsyncFbsCreate = Loadable({
	loader: () => import('../../settings/fbs/components/CreateFbs')
})

const AsyncListUserGroup = Loadable({
	loader: () => import('../../usergroup/components/ListUserGroup')
})

const AsyncCreateUserGroup = Loadable({
	loader: () => import('../../usergroup/components/CreateUserGroup')
})

const AsyncUpdateUserGroup = Loadable({
	loader: () => import('../../usergroup/components/UpdateUserGroup')
})

const AsyncViewUserGroup = Loadable({
	loader: () => import('../../usergroup/components/ViewUserGroup')
})

const AsyncCreateProfile = Loadable({
	loader: () => import('../../profile/components/CreateProfile')
})

const AsyncListProfile = Loadable({
	loader: () => import('../../profile/components/ListProfile')
})

const AsyncUpdateProfile = Loadable({
	loader: () => import('../../profile/components/UpdateProfile')
})

const AsyncViewProfile = Loadable({
	loader: () => import('../../profile/components/ViewProfile')
})

const AsyncIntegrations = Loadable({
	loader: () => import('../../settings/integration/components/Integrations')
})

const AsyncReportOverview = Loadable({
	loader: () => import('../../report/components/Overview')
})

const AsyncReportByRoom = Loadable({
	loader: () => import('../../report/components/Byroom')
})

const AsyncReportByUser = Loadable({
	loader: () => import('../../report/components/Byuser')
})

const AsyncReportRoomDetail = Loadable({
	loader: () => import('../../report/components/ReportRoomStatus')
})

const AsyncReportUserDetail = Loadable({
	loader: () => import('../../report/components/ReportUserDetail')
})

const AsyncReportOverviewDetail = Loadable({
	loader: () => import('../../report/components/OverviewDetail')
})

const AsyncReportOverviewUserDetail = Loadable({
	loader: () => import('../../report/components/OverviewUserDetail')
})

const AsyncTerm = Loadable({
	loader: () => import('../../settings/term/components/Term')
})

const AsyncEditTerm = Loadable({
	loader: () => import('../../settings/term/components/TermForm')
})

const AsyncFaq = Loadable({
	loader: () => import('../../settings/faq/components/Faq')
})

const AsyncEditFaq = Loadable({
	loader: () => import('../../settings/faq/components/FaqForm')
})

const AsyncContactUs = Loadable({
	loader: () => import('../../settings/contact/components/Contact')
})

const AsyncEditContactUs = Loadable({
	loader: () => import('../../settings/contact/components/ContactForm')
})

const AsyncFbsCategory = Loadable({
	loader: () => import('../../fbCategory/components/fbCategoryList')
})

const AsyncUpdateFbsCategory = Loadable({
	loader: () => import('../../fbCategory/components/fbCategoryUpdate')
})

const AsyncCreateFbsCategory = Loadable({
	loader: () => import('../../fbCategory/components/fbCategoryCreate')
})
const AsyncFbsCategoryView = Loadable({
	loader: () => import('../../fbCategory/components/View')
})

const AsyncExchangeIntegrations = Loadable({
	loader: () => import('../../settings/integration/components/ExchangeIntegration')
})

const AsyncGoogleIntegrations = Loadable({
	loader: () => import('../../settings/integration/components/GoogleIntegration')
})

const AsyncSettingsGoogleIntegration = Loadable({
	loader: () => import('../../settings/integration/components/SettingGoogleIntegration')
})

const AsyncSettingsExchangeIntegration = Loadable({
	loader: () => import('../../settings/integration/components/SettingExchangeIntegration')
})

const AsyncRoomQRCode = Loadable({
	loader: () => import('../../rooms/components/RoomQRCode')
})

const AsyncAdminViewEvents = Loadable({
	loader: () => import('../../events/components/viewEvents')
})

const AsyncDisplayList = Loadable({
	loader: () => import('../../display/components/displayList')
})

const AsyncRoomDisableList = Loadable({
	loader: () => import('../../roomDisable/components/roomDisableList')
})

const AsyncRoomDisableCreate = Loadable({
	loader: () => import('../../roomDisable/components/roomDisableCreate')
})

const AsyncRoomDisableUpdate = Loadable({
	loader: () => import('../../roomDisable/components/roomDisableUpdate')
})

const AsyncRoomDisableView = Loadable({
	loader: () => import('../../roomDisable/components/roomDisableView')
})

const AsyncConcurrentList = Loadable({
	loader: () => import('../../concurrent/components/ConcurrentList')
})

const AsyncRoleList = Loadable({
	loader: () => import('../../roles/components/List')
})

const AsyncRoleCreate = Loadable({
	loader: () => import('../../roles/components/Create')
})

const AsyncRoleView = Loadable({
	loader: () => import('../../roles/components/View')
})

const AsyncRoleUpdate = Loadable({
	loader: () => import('../../roles/components/Update')
})

const AsyncRoomFormatList = Loadable({
	loader: () => import('../../roomFormat/components/List')
})

const AsyncRoomFormatListCreate = Loadable({
	loader: () => import('../../roomFormat/components/Create')
})

const AsyncRoomFormatListView = Loadable({
	loader: () => import('../../roomFormat/components/View')
})

const AsyncRoomFormatListUpdate = Loadable({
	loader: () => import('../../roomFormat/components/Update')
})

const AsyncOrderFbsList = Loadable({
	loader: () => import('../../order/components/ListFbs')
})

const AsyncOrderFbsUpdate = Loadable({
	loader: () => import('../../order/components/UpdateFbs')
})

const AsyncOrderFbsView = Loadable({
	loader: () => import('../../order/components/ViewFbs')
})

const AsyncOrderCreateFbs = Loadable({
	loader: () => import('../../order/components/CreateFbs')
})

const AsyncOrderCreateAmenity = Loadable({
	loader: () => import('../../order/components/CreateAmenity')
})

const AsyncOrderAmenityList = Loadable({
	loader: () => import('../../order/components/ListAmenity')
})

const AsyncOrderAmenityUpdate = Loadable({
	loader: () => import('../../order/components/UpdateAmenity')
})

const AsyncOrderAmenityView = Loadable({
	loader: () => import('../../order/components/ViewAmenity')
})

const AsyncReportFoodSummaryByEvent = Loadable({
	loader: () => import('../../report/components/FoodSummaryByEvent')
})

const AsyncReportFacilitySummaryByEvent = Loadable({
	loader: () => import('../../report/components/FacilitySummaryByEvent')
})

const AsyncViewEventsOrder = Loadable({
	loader: () => import('../../order/components/viewEvents')
})

const AsyncEventTypeList = Loadable({
	loader: () => import('../../eventType/components/List')
})

const AsyncEventTypeView = Loadable({
	loader: () => import('../../eventType/components/View')
})

const AsyncEventTypeCreate = Loadable({
	loader: () => import('../../eventType/components/Create')
})

const AsyncEventTypeUpdate = Loadable({
	loader: () => import('../../eventType/components/Update')
})

const LogoSetting = Loadable({
	loader: () => import('../../setting/components/Logo')
})

const LogoUpdateSetting = Loadable({
	loader: () => import('../../setting/components/LogoUpdate')
})

const SessionExpire = Loadable({
	loader: () => import("./TokenExpireDialog")
})
export default () => (
	<Switch>
		<RoutePermission.PrivateRoute exact path="/" component={AsyncHome} />

		<RoutePermission.PublicRoute path="/sessionExpire" component={SessionExpire} />

		<RoutePermission.PrivateRoute path="/integration" component={AsyncIntegrations} />
		<RoutePermission.PrivateRoute path="/exchangeIntegration" component={AsyncExchangeIntegrations} />
		<RoutePermission.PrivateRoute path="/googleIntegration" component={AsyncGoogleIntegrations} />

		<RoutePermission.PublicRoute path="/login" component={AsyncLoginBSRS} />

		<RoutePermission.PrivateRoute path="/settings/integration" component={AsyncSettingsIntegration} />
		<RoutePermission.PrivateRoute path="/settings/googleIntegration" component={AsyncSettingsGoogleIntegration} />
		<RoutePermission.PrivateRoute path="/settings/exchangeIntegration" component={AsyncSettingsExchangeIntegration} />

		<RoutePermission.PrivateRoute path="/term" component={AsyncTerm} />
		<RoutePermission.PrivateRoute path="/editterm/:lang" component={AsyncEditTerm} />
		<RoutePermission.PrivateRoute path="/faq" component={AsyncFaq} />
		<RoutePermission.PrivateRoute path="/editfaq/:lang" component={AsyncEditFaq} />
		<RoutePermission.PrivateRoute path="/contact" component={AsyncContactUs} />
		<RoutePermission.PrivateRoute path="/editcontact/:lang" component={AsyncEditContactUs} />

		<RoutePermission.PrivateRoute path="/setting" component={AsyncSetting} />
		<RoutePermission.PrivateRoute path="/changesetting" component={AsyncChangeSetting} />

		<RoutePermission.PrivateRoute path="/room/system" component={AsyncListRoomsO365} />
		<RoutePermission.PrivateRoute path="/room/core/qrcode/:email" component={AsyncRoomQRCode} />
		<RoutePermission.PrivateRoute path="/room/core" component={AsyncListRoomsCore} />
		<RoutePermission.PrivateRoute path="/room/subscribe" component={AsyncListRoomsSubscribe} />
		<RoutePermission.PrivateRoute path="/room/create" component={AsyncCreateRoomNew} />
		<RoutePermission.PrivateRoute path="/room/update/:email" component={AsyncUpdateRoomNew} />
		<RoutePermission.PrivateRoute path="/room/view/:email" component={AsyncViewRoomCore} />

		<RoutePermission.PrivateRoute path="/user/o365" component={AsyncListUsersO365} />
		<RoutePermission.PrivateRoute path="/user/ad" component={AsyncListUsersAD} />
		<RoutePermission.PrivateRoute path="/user/core" component={AsyncListUsersCore} />
		<RoutePermission.PrivateRoute path="/user/create" component={AsyncCreateUser} />
		<RoutePermission.PrivateRoute path="/user/update/:id" component={AsyncUpdateUser} />
		<RoutePermission.PrivateRoute path="/user/view/:id" component={AsyncViewUserCore} />

		<RoutePermission.PrivateRoute path="/user/group/list" component={AsyncListUserGroup} />
		<RoutePermission.PrivateRoute path="/user/group/create" component={AsyncCreateUserGroup} />
		<RoutePermission.PrivateRoute path="/user/group/update/:id" component={AsyncUpdateUserGroup} />
		<RoutePermission.PrivateRoute path="/user/group/view/:id" component={AsyncViewUserGroup} />

		<RoutePermission.PrivateRoute path="/user/concurrent" component={AsyncConcurrentList} />

		<RoutePermission.PrivateRoute path="/profile/list" component={AsyncListProfile} />
		<RoutePermission.PrivateRoute path="/profile/create" component={AsyncCreateProfile} />
		<RoutePermission.PrivateRoute path="/profile/update/:id" component={AsyncUpdateProfile} />
		<RoutePermission.PrivateRoute path="/profile/view/:id" component={AsyncViewProfile} />

		<RoutePermission.PrivateRoute path="/amenity/create" component={AsyncAmenityCreate} />
		<RoutePermission.PrivateRoute path="/amenity/update/:id" component={AsyncAmenityUpdate} />
		<RoutePermission.PrivateRoute path="/amenity/view/:id" component={AsyncViewAmenity} />
		<RoutePermission.PrivateRoute path="/amenity" component={AsyncAmenity} />

		<RoutePermission.PrivateRoute path="/building/create" component={AsyncBuildingCreate} />
		<RoutePermission.PrivateRoute path="/building/update/:id" component={AsyncBuildingUpdate} />
		<RoutePermission.PrivateRoute path="/building/view/:id" component={AsyncViewBuilding} />
		<RoutePermission.PrivateRoute path="/building" component={AsyncBuilding} />

		<RoutePermission.PrivateRoute path="/background/create" component={AsyncBackgroundCreate} />
		<RoutePermission.PrivateRoute path="/background/update/:id" component={AsyncBackgroundUpdate} />
		<RoutePermission.PrivateRoute path="/background/view/:id" component={AsyncViewBackground} />
		<RoutePermission.PrivateRoute path="/background" component={AsyncBackground} />

		<RoutePermission.PrivateRoute path="/floor/create" component={AsyncFloorCreate} />
		<RoutePermission.PrivateRoute path="/floor/update/:id" component={AsyncFloorUpdate} />
		<RoutePermission.PrivateRoute path="/floor/view/:id" component={AsyncViewFloor} />
		<RoutePermission.PrivateRoute path="/floor" component={AsyncFloor} />

		<RoutePermission.PrivateRoute path="/zone/create" component={AsyncZoneCreate} />
		<RoutePermission.PrivateRoute path="/zone/update/:id" component={AsyncZoneUpdate} />
		<RoutePermission.PrivateRoute path="/zone/view/:id" component={AsyncViewZone} />
		<RoutePermission.PrivateRoute path="/zone" component={AsyncZone} />

		<RoutePermission.PrivateRoute path="/eventtype/create" component={AsyncEventTypeCreate} />
		<RoutePermission.PrivateRoute path="/eventtype/update/:id" component={AsyncEventTypeUpdate} />
		<RoutePermission.PrivateRoute path="/eventtype/view/:id" component={AsyncEventTypeView} />
		<RoutePermission.PrivateRoute path="/eventtype" component={AsyncEventTypeList} />

		<RoutePermission.PrivateRoute path="/role/view/:id" component={AsyncRoleView} />
		<RoutePermission.PrivateRoute path="/role/update/:id" component={AsyncRoleUpdate} />
		<RoutePermission.PrivateRoute path="/role/list" component={AsyncRoleList} />
		<RoutePermission.PrivateRoute path="/role/create" component={AsyncRoleCreate} />

		<RoutePermission.PrivateRoute path="/fbsCategory/update/:id" component={AsyncUpdateFbsCategory} />
		<RoutePermission.PrivateRoute path="/fbsCategory/create" component={AsyncCreateFbsCategory} />
		<RoutePermission.PrivateRoute path="/fbsCategory/:id" component={AsyncFbsCategoryView} />
		<RoutePermission.PrivateRoute path="/fbsCategory" component={AsyncFbsCategory} />

		<RoutePermission.PrivateRoute path="/fbs/create" component={AsyncFbsCreate} />
		<RoutePermission.PrivateRoute path="/fbs/update/:id" component={AsyncFbsUpdate} />
		<RoutePermission.PrivateRoute path="/fbs/view/:id" component={AsyncViewFbs} />
		<RoutePermission.PrivateRoute path="/fbs" component={AsyncFbs} />

		{/* R */}<RoutePermission.PrivateRoute path="/authorize" component={AsyncAuthorizeO365} />
		<RoutePermission.PrivateRoute path="/userInfo" component={AsyncUserInfo} />
		{/* R */}<RoutePermission.PrivateRoute path="/user/changepassword/:id" component={AsyncUserChangePassword} />

		<RoutePermission.PrivateRoute path="/report/overview/user/:range" component={AsyncReportOverviewUserDetail} />
		<RoutePermission.PrivateRoute path="/report/overview/room/:range" component={AsyncReportOverviewDetail} />
		{/* R */}<RoutePermission.PrivateRoute path="/report/user/:id" component={AsyncReportUserDetail} />
		{/* R */}<RoutePermission.PrivateRoute path="/report/room/:email" component={AsyncReportRoomDetail} />
		<RoutePermission.PrivateRoute path="/report/statussummary" component={AsyncReportSummary} />
		<RoutePermission.PrivateRoute path="/report/overview" component={AsyncReportOverview} />
		{/* R */}<RoutePermission.PrivateRoute path="/report/byroom" component={AsyncReportByRoom} />
		{/* R */}<RoutePermission.PrivateRoute path="/report/byuser" component={AsyncReportByUser} />
		<RoutePermission.PrivateRoute path="/report/roomreport" component={AsyncRoomReportNew} />
		<RoutePermission.PrivateRoute path="/report/userreport" component={AsyncUserReport} />
		<RoutePermission.PrivateRoute path="/report/usersummary" component={AsyncUserSummary} />
		<RoutePermission.PrivateRoute path="/report/roomsummary" component={AsyncRoomSummary} />
		<RoutePermission.PrivateRoute path="/report/deleteeventsummary" component={AsyncDeleteEventSummary} />

		<RoutePermission.PrivateRoute path="/report/foodsummary" component={AsyncFoodSummary} />
		<RoutePermission.PrivateRoute path="/report/facilitysummary" component={AsyncFacilitySummary} />

		<RoutePermission.PrivateRoute path="/report/foodsummarybyevent" component={AsyncReportFoodSummaryByEvent} />
		<RoutePermission.PrivateRoute path="/report/facilitysummarybyevent" component={AsyncReportFacilitySummaryByEvent} />

		<RoutePermission.PrivateRoute path="/report/notuse/user" component={AsyncReserveNotUseByUser} />
		<RoutePermission.PrivateRoute path="/report/notuse/room" component={AsyncReserveNotUseByRoom} />

		<RoutePermission.PrivateRoute path="/report/userattendance" component={AsyncReportUserAttendance} />

		<RoutePermission.PrivateRoute path="/logo/update" component={LogoUpdateSetting} />
		<RoutePermission.PrivateRoute path="/logo" component={LogoSetting} />

		<RoutePermission.PrivateRoute path="/display" component={AsyncDisplayList} />

		<RoutePermission.PrivateRoute path="/roomdisable/update/:id" component={AsyncRoomDisableUpdate} />
		<RoutePermission.PrivateRoute path="/roomdisable/view/:id" component={AsyncRoomDisableView} />
		<RoutePermission.PrivateRoute path="/roomdisable/create" component={AsyncRoomDisableCreate} />
		<RoutePermission.PrivateRoute path="/roomdisable" component={AsyncRoomDisableList} />

		<RoutePermission.PrivateRoute path="/roomformat/view/:id" component={AsyncRoomFormatListView} />
		<RoutePermission.PrivateRoute path="/roomformat/update/:id" component={AsyncRoomFormatListUpdate} />
		<RoutePermission.PrivateRoute path="/roomformat/create" component={AsyncRoomFormatListCreate} />
		<RoutePermission.PrivateRoute path="/roomformat" component={AsyncRoomFormatList} />

		<RoutePermission.PrivateRoute path="/orderfbs/create/:icaluid/:roomemail" component={AsyncOrderCreateFbs} />
		<RoutePermission.PrivateRoute path="/orderfbs/update/:id/:roomemail" component={AsyncOrderFbsUpdate} />
		<RoutePermission.PrivateRoute path="/orderfbs/view/:id/:roomemail" component={AsyncOrderFbsView} />
		<RoutePermission.PrivateRoute path="/order" component={AsyncOrderFbsList} />

		<RoutePermission.PrivateRoute path="/orderamenity/create/:icaluid/:roomemail" component={AsyncOrderCreateAmenity} />
		<RoutePermission.PrivateRoute path="/orderamenity/update/:id/:roomemail" component={AsyncOrderAmenityUpdate} />
		<RoutePermission.PrivateRoute path="/orderamenity/view/:id/:roomemail" component={AsyncOrderAmenityView} />
		<RoutePermission.PrivateRoute path="/orderamenity" component={AsyncOrderAmenityList} />

		<RoutePermission.PrivateRoute path="/events/order" component={AsyncViewEventsOrder} />
		<RoutePermission.PrivateRoute path="/events" component={AsyncAdminViewEvents} />
		<RoutePermission.PrivateRoute component={AsyncNotFound} />
	</Switch>
)


// WEBPACK FOOTER //
// ./src/features/ui/components/Routes.js